import { render, staticRenderFns } from "./EstablishmentDetails.vue?vue&type=template&id=1ca76229&scoped=true"
import script from "./EstablishmentDetails.vue?vue&type=script&lang=js"
export * from "./EstablishmentDetails.vue?vue&type=script&lang=js"
import style0 from "./EstablishmentDetails.vue?vue&type=style&index=0&id=1ca76229&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca76229",
  null
  
)

export default component.exports